import React from 'react'
import styled from 'styled-components'
import { Ellipsis, LineClamp, Small } from 'components/styled/typography'
import { Box } from 'components/styled/containers/box'
import { convertRateToStars } from 'utils/rating'
import { connect } from 'react-redux'
import { I18nComponentType } from 'i18n/i18n-types'
import { mapLanguageToComponentProps } from 'i18n'
import { Flex } from 'components/styled/containers/flex'
import { StarBox, FilledStar } from '../star-icon'
import { RatingType } from '../index'

interface RatingsListProps {
  ratings?: RatingType[]
  i18n: I18nComponentType
}

const RatingsContainer = styled(Box)`
  border-bottom: 1px solid;
  width: 100%;
  border-bottom-color: ${({ theme }) => theme.color.grey20};
  overflow: hidden;
`
const NameContainer = styled(Small)`
  word-break: break-all;
  ${Ellipsis};
  ${({ numberOfLines }) => numberOfLines && LineClamp};
  text-align: left;
`

// TODO Translations
export const RatingsListFC = ({ i18n, ratings = [] }: RatingsListProps) => {
  return (
    <>
      <RatingsContainer mb="s16" mt="s8">
        {ratings.map(({ admin, adminName, value }) => (
          <Flex
            key={admin}
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
            mb="s12"
          >
            <NameContainer
              mb="s0"
              mr="s8"
              numberOfLines={1}
              data-testid={adminName}
            >
              {adminName}
            </NameContainer>
            <Flex
              flexDirection="row"
              justifyContent="right"
              alignItems="center"
            >
              <Small mb="s0">{convertRateToStars(value)?.toFixed(0)}</Small>
              <StarBox size="small">
                <FilledStar
                  $disabled={false}
                  $isHovered={false}
                  $size="small"
                  $percentage={100}
                  $hasOwnRating
                />
              </StarBox>
            </Flex>
          </Flex>
        ))}
        {ratings.length === 0 && (
          <Small mb="s16" fontStyle="italic">
            {i18n.rating.noRatings}
          </Small>
        )}
      </RatingsContainer>
      <Small mb="s8" textAlign="right">
        {i18n.rating.totalVotes(ratings.length)}
      </Small>
    </>
  )
}

export const RatingsList = connect<{
  i18n: I18nComponentType
}>(mapLanguageToComponentProps())(RatingsListFC)
